import $ from 'jquery';
import moment from 'moment';

class VacancyLoader {
	constructor() {
		this.API_ID = "48PmBdkEwdXyJxx5yUglBU5HQOqKXzHJRMIINQD9Erw";
		this.API_MAPDATA_URL = "https://app.vacancy-filler.co.uk/VFMVC/CareerPage/GetMapData";
		this.API_REGION_URL = "https://app.vacancy-filler.co.uk/VFMVC/CareerPage/GetRegions";
		this.API_LOCATION_URL = "https://app.vacancy-filler.co.uk/VFMVC/CareerPage/GetLocations";
		this.events();
	}

	events() {
		const that = this;

		$(function() {
			that.getRegions();
			that.getLocations();
			that.getView();

			const $ddlLocations = $('#ddlLocations');

			$("#ddlRegions").change(function ()
			{
				$ddlLocations.prop('selectedIndex', 0);
				that.getLocations();
				that.getView();
			});

			$ddlLocations.change(function ()
			{
				that.getView();
			});
		});
	}

	getView() {
		const that = this,
			  $ddlRegions = $("#ddlRegions"),
			  $ddlLocations = $("#ddlLocations");

		const dataObj = {
			id: that.API_ID,
			mask: "111111111111111111111",
			results: 10,
			dateformat: "HH:mm, dd MMMM yyyy",
			sortBy: "region",
			sortDir: "asc",
			postingtype: typeof(thPostingTypes) !== 'undefined'? thPostingTypes : null
		};

		if ($ddlRegions.val() != "-- Please select --" && $ddlRegions.val() != null)
		{
			dataObj.region = $ddlRegions.val();
		}

		if ($ddlLocations.val() != "-- Please select --" && $ddlLocations.val() != null)
		{
			dataObj.location = $ddlLocations.val();
		}

		if ($ddlRegions.val() != "-- Please select --" && $ddlRegions.val() != null)
		{
			dataObj.location = $ddlRegions.val();
		}

		$.ajax({
			url: that.API_MAPDATA_URL,
			data: dataObj,
			type: "GET",
			dataType: "jsonp",
			jsonp: "callback",
			success: function (data) {
				var html = "";

				$.each(data, function (index, item) {
					var timestamp = item.ExpiryDate.replace(/[^\d]/ig, ''),
						expiry = new Date(parseInt(timestamp));

					html += "<li class='job'><h2 class='text-standfirst'>" + item.JobTitle + "</h2>" +
						"<div><h3>Reference</h3><p>" + item.AdvertReference + "</p></div>" +
						"<div><h3>Location</h3><p>" + item.Location + "</p></div>" +
						"<div><h3>Category</h3><p>" + item.JobCategory + "</div>" +
						"<div><h3>Job Type</h3><p>" + item.JobType + "</div>" +
						"<div><h3>Salary</h3><p>" + item.Currency + item.SalaryFrom + '.00 &dash; ' + item.Currency + item.SalaryTo + ".00 " + item.SalaryPeriod + "</div>" +
						"<div><h3>Benefits</h3><p>" + item.Benefits + "</div>" +
						"<div><h3>Closing Date</h3><p>" + moment.unix(timestamp / 1000).format('DD MMMM YYYY HH:mm') + "</div>" +
						"<div class='summary'>" + item.Description + "</div>" +
						"<a href='" + item.Link + "'>More Details</a>" +
						"</li>";
				});

				$("#divResult").html("<ul id='jobs'>" + html + '</ul>');
			}
		}).error(function (xhr, status, error) {
			console.log("An AJAX error occured in View: " + status + "\nError: " + error + "\nError detail: " + xhr.responseText);
		});
	}

	getRegions() {
		const that = this,
			  $ddlRegions = $('#ddlRegions');

		$.ajax({
			url: that.API_REGION_URL,
			data: {
				id: that.API_ID
			},
			type: "GET",
			dataType: "jsonp",
			jsonp: "callback",
			success: function (data)
			{
				$ddlRegions.html("");
				var row = "";
				$ddlRegions.append("<option>-- Please select --</option>");
				$.each(data, function (index, item)
				{
					$ddlRegions.append("<option>"+ item +"</option>");
				});

			}
		}).error(function (xhr, status, error)
		{
			console.log("An AJAX error occured in Regions: " + status + "\nError: " + error + "\nError detail: " + xhr.responseText);
		});
	}

	getLocations() {
		const that = this,
			  $ddlRegions = $("#ddlRegions"),
			  $ddlLocations = $('#ddlLocations');

		const dataObj = {
			id: that.API_ID
		};

		if ($ddlRegions.val() != "-- Please select --" && $ddlRegions.val() != null)
		{
			dataObj.region = $ddlRegions.val()
		}

		$.ajax({
			url: that.API_LOCATION_URL,
			data: dataObj,
			type: "GET",
			dataType: "jsonp",
			jsonp: "callback",
			success: function (data)
			{
				$ddlLocations.html("");
				var row = "";
				$ddlLocations.append("<option value=''>All Locations</option>");
				$.each(data, function (index, item)
				{
					$ddlLocations.append("<option value='" + item + "'>" + item + "</option>");
				});
			}
		}).error(function (xhr, status, error)
		{
			console.log("An AJAX error occured in Locations: " + status + "\nError: " + error + "\nError detail: " + xhr.responseText);
		});
	}

}

export default {
	init() {
		if($('#vacancies').length) {
			new VacancyLoader();
		}
	}
};


// WEBPACK FOOTER //
// ./src/js/modules/vacancyLoader.js